module.exports = __webpack_public_path__ + "static/img/icon-print.2c82600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myBrand/component/img/icon-print.svg
// module id = Z+Z3
// module chunks = 55